import { lazy } from "react";
import { Route } from "react-router-dom";

/**
 * Demo agent routes — all commented out by default.
 * To activate an agent: uncomment its lazy import AND its matching <Route> below.
 */
// const OutboundCallAgent = lazy(() => import("@/demo/pages/agents/OutboundCallAgent"));
// const LeadFunnelAnalyser = lazy(() => import("@/demo/pages/agents/LeadFunnelAnalyser"));
const Recki = lazy(() => import("@/demo/pages/agents/Recki"));

// JSX constant (not a component) so React Router can traverse the Fragment directly
export const DemoRoutes = (
  <>
    {/* Uncomment each route alongside its lazy import above */}
    {/* <Route path="/ui/agent/outbound-call-ai-agent" element={<OutboundCallAgent />} /> */}
    {/* <Route path="/ui/agent/lead-funnel-analyser-demo" element={<LeadFunnelAnalyser />} /> */}
    <Route path="/ui/agent/recki" element={<Recki />} />
  </>
);
